/**
 * The one module of this package that imports `zod`. Every other module takes `z` from here, so
 * this module's body runs before the body of any module that builds a schema, in every entry,
 * whatever the consumer imports first (an ES module's dependencies finish evaluating before its
 * own body starts). The entry-boundaries spec holds every entry to that rule.
 *
 * `jitless: true`: Zod 4's object-schema constructor probes whether `new Function` works, to
 * decide whether to compile a fast parser. Under the app's content security policy
 * (`script-src 'self'`, no `'unsafe-eval'`) the browser reports that probe as a
 * `securitypolicyviolation`, even though Zod catches the error, on every page that loads a DTO.
 * With `jitless` Zod skips the probe and parses with its interpreter, which gives the same
 * results. The setting lives in Zod's global configuration (`globalThis.__zod_globalConfig`), so
 * it also covers schemas a consumer builds after importing this package, and it applies on the
 * server too. Consumers need no configuration of their own.
 *
 * **String lengths count code points** (the contract steward's convention, CS r1). Every
 * `.min()`, `.max()` and `.length()` on a string in contracts and in `@codex/dnd5e`'s schemas
 * counts Unicode code points: an astral character (an emoji) is one. Zod 4, JSON Schema's
 * `maxLength` and PostgreSQL's `char_length` agree on that. A bound meant in UTF-16 code units
 * or in bytes is a pattern or a refinement whose comment says so, as the callout icon's
 * `CALLOUT_ICON_PATTERN` is (code units). `test/string-lengths.test.ts` holds both.
 */
import { z } from 'zod';
z.config({ jitless: true });
export { z };
//# sourceMappingURL=zod.js.map